import React from 'react';
import { Typography, GRAY } from '@applyboard/ui-components';
export var NOT_ACCEPTED = 'Not accepted';
export var NotAccepted = function NotAccepted() {
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: GRAY[15]
    }
  }, NOT_ACCEPTED);
};